import React from "react";

// Pagination Component
function Pagination({ currentPage, totalPages, onPageChange, style }) {
  const maxPageButtons = 10;
  const currentGroup = Math.floor((currentPage - 1) / maxPageButtons);
  const startPage = currentGroup * maxPageButtons + 1;
  const endPage = Math.min(startPage + maxPageButtons - 1, totalPages);

  const handlePrevGroup = () => {
    const prevStartPage = startPage - maxPageButtons;
    if (prevStartPage >= 1) {
      onPageChange(prevStartPage);
    }
  };

  const handleNextGroup = () => {
    const nextStartPage = startPage + maxPageButtons;
    if (nextStartPage <= totalPages) {
      onPageChange(nextStartPage);
    }
  };


  return (
    <div style={{...styles.boardPage, ...style,}}>
      {/* previous Group */}
      <div
        onClick={handlePrevGroup}
        style={{
          ...styles.arrowButton,
          cursor: startPage === 1 ? "not-allowed" : "pointer",
          pointerEvents: startPage === 1 ? "none" : "auto",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          style={{
            fill:
              startPage === 1
                ? "var(--grayscale-cool_50)"
                : "var(--primary-crimson_40)",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0303 4.71967C13.3232 5.01256 13.3232 5.48744 13.0303 5.78033L8.56066 10.25L13.0303 14.7197C13.3232 15.0126 13.3232 15.4874 13.0303 15.7803C12.7374 16.0732 12.2626 16.0732 11.9697 15.7803L6.96967 10.7803C6.67678 10.4874 6.67678 10.0126 6.96967 9.71967L11.9697 4.71967C12.2626 4.42678 12.7374 4.42678 13.0303 4.71967Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.0303 4.71967C9.32319 5.01256 9.32319 5.48744 9.0303 5.78033L4.56066 10.25L9.0303 14.7197C9.32319 15.0126 9.32319 15.4874 9.0303 15.7803C8.73741 16.0732 8.26253 16.0732 7.96964 15.7803L2.96967 10.7803C2.67678 10.4874 2.67678 10.0126 2.96967 9.71967L7.96964 4.71967C8.26253 4.42678 8.73741 4.42678 9.0303 4.71967Z"
          />
        </svg>
      </div>
      {/* Previous Button */}
      <div
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        style={{
          ...styles.arrowButton,
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          pointerEvents: currentPage === 1 ? "none" : "auto",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          style={{
            fill:
              currentPage === 1
                ? "var(--grayscale-cool_50)"
                : "var(--primary-crimson_40)",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0303 4.71967C13.3232 5.01256 13.3232 5.48744 13.0303 5.78033L8.56066 10.25L13.0303 14.7197C13.3232 15.0126 13.3232 15.4874 13.0303 15.7803C12.7374 16.0732 12.2626 16.0732 11.9697 15.7803L6.96967 10.7803C6.67678 10.4874 6.67678 10.0126 6.96967 9.71967L11.9697 4.71967C12.2626 4.42678 12.7374 4.42678 13.0303 4.71967Z"
          />
        </svg>
      </div>

      {/* Page Buttons */}
      <div style={styles.pageButtonGroup}>
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
          const pageNum = startPage + i;
          return (
            <button
              key={pageNum}
              className="font-body3-semibold"
              style={{
                ...styles.pageButton,
                ...(currentPage === pageNum ? styles.activePage : {}),
              }}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}
      </div>

      {/* Next Button */}
      <div
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        style={{
          ...styles.arrowButton,
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          pointerEvents: currentPage === totalPages ? "none" : "auto",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          style={{
            fill:
              currentPage === totalPages
                ? "var(--grayscale-cool_50)"
                : "var(--primary-crimson_40)",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.96967 15.7803C6.67678 15.4874 6.67678 15.0126 6.96967 14.7197L11.4393 10.25L6.96967 5.78033C6.67678 5.48744 6.67678 5.01256 6.96967 4.71967C7.26256 4.42678 7.73744 4.42678 8.03033 4.71967L13.0303 9.71967C13.3232 10.0126 13.3232 10.4874 13.0303 10.7803L8.03033 15.7803C7.73744 16.0732 7.26256 16.0732 6.96967 15.7803Z"
          />
        </svg>
      </div>
      {/* next 그룹 버튼 */}
      <div
        onClick={handleNextGroup}
        style={{
          ...styles.arrowButton,
          cursor: endPage === totalPages ? "not-allowed" : "pointer",
          pointerEvents: endPage === totalPages ? "none" : "auto",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          style={{
            fill:
              endPage === totalPages
                ? "var(--grayscale-cool_50)"
                : "var(--primary-crimson_40)",
          }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.96967 15.7803C6.67678 15.4874 6.67678 15.0126 6.96967 14.7197L11.4393 10.25L6.96967 5.78033C6.67678 5.48744 6.67678 5.01256 6.96967 4.71967C7.26256 4.42678 7.73744 4.42678 8.03033 4.71967L13.0303 9.71967C13.3232 10.0126 13.3232 10.4874 13.0303 10.7803L8.03033 15.7803C7.73744 16.0732 7.26256 16.0732 6.96967 15.7803Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9697 15.7803C10.6768 15.4874 10.6768 15.0126 10.9697 14.7197L15.4393 10.25L10.9697 5.78033C10.6768 5.48744 10.6768 5.01256 10.9697 4.71967C11.2626 4.42678 11.7374 4.42678 12.0303 4.71967L17.0303 9.71967C17.3232 10.0126 17.3232 10.4874 17.0303 10.7803L12.0303 15.7803C11.7374 16.0732 11.2626 16.0732 10.9697 15.7803Z"
          />
        </svg>
      </div>
    </div>
  );  
}

const styles = {
  boardPage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px"
  },  
  arrowButton:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageButtonGroup:{
    display: "flex",
    gap: "8px"
  },
  pageButton: {
    display: "flex",
    color :"var(--grayscale_50)",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "0px",
    padding: "0px 8px",
  },
  activePage: {
    borderRadius: "26px",
    backgroundColor: "var(--grayscale_20)",
    color: "var(--primary-crimson_40)",
    fontWeight: "bold",
  },
}

export default Pagination;